// Copyright (c) 2016 Deere & Company

import {FormattedMessage} from 'react-intl';
import React from 'react';

const AmountOfUsePanelRequestListHeader = () =>
    <section className='amount-of-use-request-list-header'>
        <span className='request'>
            <FormattedMessage id='REQUEST'/>
        </span>
        <span className='date'>
            <FormattedMessage id='DATE'/>
        </span>
        <span className='amountOfUse'>
            <FormattedMessage id='AMOUNT_OF_USE'/>
        </span>
        <span className='status'>
            <FormattedMessage id='STATUS'/>
        </span>
        <span className='tcsmComments'>
            <FormattedMessage id='TCSM_COMMENTS'/>
        </span>
    </section>;

AmountOfUsePanelRequestListHeader.displayName = 'AmountOfUsePanelRequestListHeader';

export default AmountOfUsePanelRequestListHeader;



// WEBPACK FOOTER //
// ./src/product/details/components/amount-of-use-history-panel/amount-of-use-panel-request-list-header.js